import { Status, type AsyncState } from '@essent/common';
import { createReducer, on } from '@ngrx/store';
import { type ContactFormType, type CustomerType } from '@innogy/feh/shared';
import type {
  GetValidatePostalCodeHouseScanV1Response,
  PostHousescanV1Response,
} from '@integration/api-client/feh';
import { FehApiActions } from '@feh/shared-api';

import { updateFormConfig } from './sustainability.actions';

// createLeadResult
export const sustainabilityCreateLeadResultId =
  'sustainabilityCreateLeadResult';

export type SustainabilityCreateLeadResultState =
  AsyncState<PostHousescanV1Response>;

export const sustainabilityCreateLeadResultReducer =
  createReducer<SustainabilityCreateLeadResultState>(
    {
      status: Status.IDLE,
    },
    on(FehApiActions.postHousescanV1.successAction, (_, params) => ({
      status: Status.SUCCESS,
      data: params.payload,
    })),
    on(FehApiActions.postHousescanV1.errorAction, (_, params) => ({
      status: Status.ERROR,
      error: params.payload,
    }))
  );

// postcodeValidation
export const sustainabilityPostcodeValidationId =
  'sustainabilityPostcodeValidation';

export type SustainabilityPostcodeValidationState =
  AsyncState<GetValidatePostalCodeHouseScanV1Response>;

export const sustainabilityPostcodeValidationReducer =
  createReducer<SustainabilityPostcodeValidationState>(
    {
      status: Status.IDLE,
    },
    on(FehApiActions.getValidatePostalCodeHouseScanV1.requestAction, () => ({
      status: Status.PENDING,
    })),
    on(
      FehApiActions.getValidatePostalCodeHouseScanV1.successAction,
      (_, params) => ({
        status: params.payload.valid ? Status.SUCCESS : Status.ERROR,
        data: params.payload,
      })
    ),
    on(
      FehApiActions.getValidatePostalCodeHouseScanV1.errorAction,
      (_, params) => ({
        status: Status.ERROR,
        data: undefined,
        error: params.payload,
      })
    )
  );

// formConfig
export const sustainabilityFormConfigId = 'sustainabilityFormConfig';

export interface SustainabilityFormConfigState {
  formType: ContactFormType;
  customerType: CustomerType;
  scanId: string;
  product: string;
}

export const sustainabilityFormConfigReducer =
  createReducer<SustainabilityFormConfigState>(
    {
      formType: '',
      customerType: 'Consument',
      scanId: '',
      product: '',
    },
    on(updateFormConfig, (state, params) => ({
      ...state,
      ...params.formConfig,
    }))
  );
